import React, { Component } from 'react';
import UtilService from "../../services/util.service";
import ConfirmationBox from '../common-components/confirmation-box.component'
import PlatformType from "../../enums/PlatformType"
import {CountriesInPack}  from '../../constants/InternationRoamingPacksAndCountriesMapping'
import TemplateName from '../../enums/templateName'
import { SCRIPTS } from "../../constants/staticScripts";
import UserActionClass from '../../objectClasses/user-action-class'
import UserActionType from '../../enums/UserActionType'

const DeactivateIrPack = ({message,showPopup,template_name,handleUserAction,messageTime,template_list,chatItem,setBottomBarToInput}) => {
    // console.log(template_list)
    let data = message
   try {
       data = JSON.parse(data)
   }
   catch (e) {
       data = undefined
   }
//    console.log(data)
   let  packs = data ? data : undefined;
   if(!template_list.includes(TemplateName.IR_SERVICE_DEACTIVATION)){
    packs = packs.filter((pack)=>!(pack.price==="149" || pack.price==="99" || pack.price==="0"))
   }

    const deactivateIrpack = (pack) => {
        let popup_message = null
        if(template_list.includes(TemplateName.IR_MULTIPLE_ZONE_PACKS)){
            popup_message = `Do you want me to deactivate your IR pack @ Rs.${pack.price}`
        }
        else if(template_list.includes(TemplateName.IR_SINGLE_ZONE_PACKS)){
            popup_message= `While deactivating IR pack, IR service will also get deactivated. Do you want me to proceed?`
        }
        else if(template_list.includes(TemplateName.IR_SERVICE_DEACTIVATION)){
            popup_message = `IR service will also get deactivated. Do you want me to proceed?`
        }

        showPopup(
            <ConfirmationBox
                title={'Deactivate IR Pack'}
                messages={[popup_message]}
                buttons={[
                    {
                        label: 'No',
                        onClick: () => {
                            showPopup(undefined)
                            setBottomBarToInput()
                            chatItem.scenarioResponse.templateNameList = [];
                            // handleOptionsClick({option_params:{ ...chatItem,
                            //         option_selected:"No",
                            //         actionType: 'CHOICE_CLICKED'},
                            // userActionObject: new UserActionClass(UserActionType.CHOICE_CLICKED,'No')
                            //     })
                            handleUserAction(new UserActionClass(UserActionType.CHOICE_CLICKED,'No'))
                            UtilService.disableDeactivateIrCardLink()
                        }
                    },
                    {   highlight:true,
                        label: 'Yes',
                        onClick: () => {
                            showPopup(undefined)
                            setBottomBarToInput()
                            // handleOptionsClick({option_params:{ ...chatItem,
                            //     option_selected:pack.id,
                            //     pack:pack,
                            //     actionType: 'CHOICE_CLICKED'},
                            // userActionObject: new UserActionClass(UserActionType.CHOICE_CLICKED,pack.id,null,null,`I want to deactivate pack of Rs. ${pack.price}`)
                            // })
                            handleUserAction(new UserActionClass(UserActionType.CHOICE_CLICKED,pack.id,null,null,`I want to deactivate pack of Rs. ${pack.price}`))
                            UtilService.disableDeactivateIrCardLink()
                        }
                    },

                ]}/>
         )
     }

    const showCountries = (pack)=>{
         showPopup(
             <div>
                 <p className="pull-right cursor-pointer" onClick={()=>{
                    showPopup()
                }}><img src={`${process.env.PUBLIC_URL}/assets/images/outlined-cross.svg`} width="15"/></p>
                 <p className="fs-20 color-dark-grey">
                        Countries for this pack are:
                </p>
                <div className="country_list">
                 <table className="width-full border-collapse" >
                {CountriesInPack[pack.id].map((country, index) =>{

                        return (
                            <tr className="border-bottom-bar">
                                <td className="border-bottom-bar pt-10 pb-10"><p className="fs-12 color-6-grey">{country}</p></td>
                            </tr>
                        )
                })}
            </table>
            </div>
             </div>
         )
     }

    return (
        <div id={`plans_scroll_${messageTime.timestamp}`} style={{alignItems:'center',display:'flex'}} className={`monthly-plan monthly-plan-scroll ${(false && packs && packs.length > 1) ? 'pl-10' : 'monthly-plan-single pl-67'}`} >
            {!packs && <ul className="bubbles relate pl-67 relate-0" ><li><p>{SCRIPTS.NO_SYSTEM_INFO_MESSAGE}</p></li></ul>}
            {(UtilService.getPlatformType()===PlatformType.WEB) &&  packs && <div className="carousel_web_arrows">
                <div><button className="arrow_button_left"
                    onClick={()=>{
                        UtilService.startScrollingLeft(`plans_scroll_${messageTime.timestamp}`);
                    }}
                >&#8249;</button></div>
                <div><button className="arrow_button_right"
                    onClick={()=>{
                        UtilService.startScrollingRight(`plans_scroll_${messageTime.timestamp}`);
                    }}
                >&#8250;</button></div>
            </div>}
            <ul className="carousel_list">
                {packs && packs.map((pack,index)=>{
                return (
                    <li key={index} className="monthly_plan_item">
                        <div
                           className=" plan-details color-black">
                            <span className="fs-8 display-block color-grey pl-10  pt-15">{pack.packName}</span>

                            <span className="fs-20 display-block color-dark-grey  pl-10">Rs. {pack.price}</span>
                            <span className="line"/>
                            <ul className="benifits">
                                <li >{pack.finalDisplayText}</li>
                               {CountriesInPack[pack.id] && CountriesInPack[pack.id].length > 0 &&  <li><a className="cursor-pointer color-link" onClick={()=>{showCountries(pack)}}>List of Countries</a></li>}
                            </ul>
                            <button 
                                disabled={(message.fromHistory) ? true : false}
                                style={{opacity:message.fromHistory ? 0.5 : 1 }}
                                className="dir-card-links color-link fs-12 activate cursor-pointer"
                                onClick={()=>{
                                
                                deactivateIrpack(pack)
                            }}
                            className="dir-card-links cursor-pointer billplan-card-links color-link fs-12 display-block  activate">DEACTIVATE</button>
                        </div>
                    </li>
                )
            })}

            </ul>
        </div>
    );
}

export default DeactivateIrPack;


// WEBPACK FOOTER //
// ./src/components/message-components/deactivate-ir-pack.component.js